var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteForever = function SvgDeleteForever(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2 5.8H18.8V5.2H15.2584L14.4795 3.64223C14.344 3.3712 14.0669 3.2 13.7639 3.2H10.2361C9.93305 3.2 9.65604 3.3712 9.52053 3.64223L8.74164 5.2H5.2V5.8ZM20 7H4V5C4 4.44772 4.44772 4 5 4H8L8.44721 3.10557C8.786 2.428 9.47852 2 10.2361 2H13.7639C14.5215 2 15.214 2.428 15.5528 3.10557L16 4H19C19.5523 4 20 4.44772 20 5V7ZM19 8H5V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V8ZM17.8 9.2V20C17.8 20.4418 17.4418 20.8 17 20.8H7C6.55817 20.8 6.2 20.4418 6.2 20V9.2H17.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8485 15L15.4243 12.4243L14.5757 11.5757L12 14.1515L9.42427 11.5757L8.57574 12.4243L11.1515 15L8.57574 17.5757L9.42427 18.4243L12 15.8485L14.5757 18.4243L15.4243 17.5757L12.8485 15Z"
  })));
};
export default SvgDeleteForever;